import { RouteConfig } from "vue-router";

import { AdminRoute } from "./admin";
import { ApplicationRouteRoute } from "./ap";

export const Group: Array<RouteConfig> = [
  ...AdminRoute,
  ...ApplicationRouteRoute
];
